import React, { Component } from 'react';
import { ControlLabel, FormControl, Checkbox, FormGroup, HelpBlock } from 'react-bootstrap';
import { getLeaderName, get } from './util/Utility.js';

class PermissionCheck extends Component {
  render() {

    let context = this.props.context;
    let item = this.props.item;

    return (
      <Checkbox checked={context.state.users[context.state.user][item] === true} onChange={() => {
        let users = context.state.users;
        let user = users[context.state.user];
        if (user[item]) {
          user[item] = false;
        } else {
          user[item] = true;
        }
        context.setState({users});
      }}>{this.props.title}</Checkbox>
    )
  }
}

export default class Permissions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: null,
      user: this.props.user.uid,
      ministries: null
    };

    get("ministries", this, null, (item) => { return !item.archived }).then(ministries => {
      this.setState({ministries});
    });
  }

  componentDidMount() {
    this.remove = window.base.syncState('permissions', {
      context: this,
      state: 'users',
      asArray: false 
    });
  }

  componentWillUnmount() {
    window.base.removeBinding(this.remove);
  }

  render() {

    if (this.state.users === null || this.state.user === null || this.state.ministries === null) { return (<div />); }

    let ministryOptions = this.state.ministries.map(ministry => {
      if (!this.state.users.hasOwnProperty(this.state.user))
        return <div />;

      const ministries = this.state.users[this.state.user].ministries;
      return <Checkbox key={ministry.name} checked={ministries !== undefined && ministries.hasOwnProperty(ministry.key)} onChange={() => {
        let users = this.state.users;
        let user = users[this.state.user];
        let key = ministry.key;
        if (user.ministries) {
          if (user.ministries.hasOwnProperty(key)) {
            user.ministries[key] = null;
          } else {
            user.ministries[key] = true
          }
        } else {
          user.ministries = {};
          user.ministries[key] = true;
        }
        this.setState({users});
      }}>{ministry.name}</Checkbox>
    })


    return (
      <center>
        <div style={{maxWidth: 350, padding: 10, textAlign: 'left'}}>
          <FormGroup key="group" controlId="group">
            <ControlLabel>Select User</ControlLabel>
            <FormControl componentClass="select" value={this.state.user} onChange={(e) => {
              this.setState({user: e.target.value});
            }}>
              {Object.keys(this.state.users).sort((a, b) => {
                let aName = getLeaderName(a), bName = getLeaderName(b);
                if(aName < bName) return -1;
                if(aName > bName) return 1;
                return 0;
              }).map(item => { return <option key={item} value={item}>{getLeaderName(item)}</option>})}
            </FormControl>
          </FormGroup>

          <FormGroup key="ministries" controlId="ministries">
            <ControlLabel>Ministries</ControlLabel>
            {ministryOptions}
          </FormGroup>

          <FormGroup key="approvals" controlId="approvals">
            <ControlLabel>Approvals</ControlLabel>
            <PermissionCheck key="1" item="approval1" context={this} title="Space Availability Approval" />
            <PermissionCheck key="2" item="approval2" context={this} title="Validity Approval" />
            <PermissionCheck key="3" item="approval3" context={this} title="Technical Equipment Availability Approval" />
            <PermissionCheck key="4" item="approval4" context={this} title="Final Approval" />
          </FormGroup>

          <FormGroup key="admin" controlId="admin">
            <ControlLabel>Administrative</ControlLabel>
            <PermissionCheck key="sermons" item="sermons" context={this} title="Sermons" />
            <PermissionCheck key="userApproval" item="userApproval" context={this} title="User Approval" />
            <PermissionCheck key="editMinistries" item="editMinistries" context={this} title="Edit Ministries (Create/Delete)" />
            <PermissionCheck key="bugs" item="bugs" context={this} title="View Bugs and Feature Requests" />
            <PermissionCheck key="permissions" item="permissions" context={this} title="Edit Permissions" />
            <PermissionCheck key="financial" item="financial" context={this} title="View Financial Information" />
            <HelpBlock>Note: Page must be refeshed for permission changes to take affect</HelpBlock>
          </FormGroup>
        </div>
      </center>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/Permissions.js
 **/